import React from 'react';
import { Box } from '@mui/material';

import { CountBadge } from '@europrocurement/flexy-components';

import { LinkedCataloguesStatus } from './useLinkedCatalogues';

type LinkedCataloguesTabTitleProps = {
    status: LinkedCataloguesStatus;
    count: number;
    label?: string;
};

/**
 * Titre de l'onglet « Catalogues » avec son compteur :
 * - pendant le chargement, le badge affiche « … » ;
 * - une fois chargé, il affiche le nombre de catalogues (masqué si aucun).
 */
const LinkedCataloguesTabTitle: React.FunctionComponent<LinkedCataloguesTabTitleProps> = function (
    props,
) {
    const { status, count, label = 'Catalogues' } = props;
    const isLoading = status === 'idle' || status === 'loading';
    const showBadge = isLoading || count > 0;

    return (
        <Box sx={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
            {label}
            {showBadge ? <CountBadge count={isLoading ? '…' : count} /> : null}
        </Box>
    );
};

export default LinkedCataloguesTabTitle;
